import { render } from "./Factories.vue?vue&type=template&id=3ef13b94&lang=pug"
import script from "./Factories.vue?vue&type=script&lang=js"
export * from "./Factories.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__